
import { defineComponent, provide, reactive } from 'vue';
import { CardProvider } from '@/components/ui-elements';

export default defineComponent({
	props: {
		color: {
			default: 'white',
		},
	},
	setup() {
		const cardContents: Record<string, boolean> = reactive({
			content: false,
			footer: false,
			header: false,
		});

		const setCardContent = (type: string) => {
			if ({}.propertyIsEnumerable.call(cardContents, type)) {
				cardContents[type] = true;
			}
		};

		provide(CardProvider, { setCardContent });

		return { cardContents };
	},
});
